import './styles.scss';
import { BucketDataType, TagType } from '../../../types/bucketTypes';

import { LocationHistoryPage } from '../../location-history-page/location-history-page';
function MainContainer({children}:{readonly children: React.ReactNode}) {
    return <div className='tab-body location-container'>{children}</div>
}
export default function LocationTab({asset, tagData}:{readonly asset: BucketDataType, readonly tagData: TagType}) { 

    return(
        <MainContainer>
            <LocationHistoryPage selectedAsset={asset} />
        </MainContainer>
    )
}